<template>
	<DividerAutoDirection>{{ $t('base-stations-edit.fields.ftpAccessDivider') }}</DividerAutoDirection>
	<Row>
		<Col span="24">
			<Col offset="4" span="20">
				<TypographyParagraph class="pd-md-x">
					{{ $t('base-stations-edit.fields.ftpPushOutHint') }}
				</TypographyParagraph>
			</Col>
			<FormItem :label="$t('base-stations-edit.fields.ftpUsernamePassword')"
				:label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<template v-if="formState.mntpntInt">
					<span class="pd-md-x">
						{{ formState.mntpntInt }} /
						{{ formState.ftpPassword }}
					</span>
					<Button @click.prevent="onFtpPasswordReset" :loading="isResetting">
						<template #icon>
							<RedoOutlined />
						</template>
						{{ $t('base-stations-edit.fields.ftpPasswordResetButtonLabel') }}
					</Button>
				</template>
				<TypographyText v-else type="secondary" class="pd-md-x">
					{{ $t('base-stations-edit.fields.ftpCredentialsMntptIntRequired') }}
				</TypographyText>
			</FormItem>
		</Col>
	</Row>
	<Row>
		<Col span="24">
			<FormItem :label="$t('base-stations-edit.fields.hostAddress')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
				<span class="pd-md-x">
					{{ formSettings.netStatusData.containerIpAddr }}:{{ formSettings.netStatusData.ftpPort }}
				</span>
			</FormItem>
		</Col>
	</Row>
</template>

<script>
import { ref, toRef } from 'vue';

import { Row, Col, FormItem, Button, TypographyText, TypographyParagraph } from 'ant-design-vue';
import { RedoOutlined } from '@ant-design/icons-vue';

import { showErrorMessage } from '@/components/common/errorMessage';

import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';

import ApiBaseStations from '@/api/ApiBaseStations';
import Utils from '@/api/Utils';

import { useSubformFieldProxy } from '@/components/addBaseStation/useSubformFieldProxies';


export default {
	components: {
		Row, Col, FormItem, Button, TypographyText, TypographyParagraph,
		RedoOutlined,
		DividerAutoDirection,
	},
	emits: ['updateFormState'],
	props: ['formState', 'formSettings', 'baseStationId', 'loadBaseStationDetails'],
	setup(props, { emit }) {
		const ftpPassword = useSubformFieldProxy(props.formState, 'ftpPassword', emit);
		const baseStationIdRef = toRef(props, 'baseStationId');
		const isResetting = ref(false);
		const onFtpPasswordReset = () => {
			if (baseStationIdRef.value !== 0) {
				isResetting.value = true;
				ApiBaseStations.baseStationChangeStatus(baseStationIdRef.value, 'update_ftp_password', responseData => {
					isResetting.value = false;
					if (responseData.status === 'ok') {
						props.loadBaseStationDetails();
					} else {
						showErrorMessage(responseData.errors)
					}
				});
			} else {
				ftpPassword.value = Utils.getRandomString(10);
			}
		};
		return {
			isResetting,
			onFtpPasswordReset,
		}
	}
}
</script>
